/* eslint-disable @next/next/no-img-element */
/* This example requires Tailwind CSS v2.0+ */
import { Fragment } from "react";
import PropTypes from "prop-types";
import { Disclosure, Popover, Transition } from "@headlessui/react";
import { SearchIcon, MenuIcon, XIcon } from "@heroicons/react/outline";
import Button from "../Button";
import { sampleData, mobileNav } from "./navigationData";
import { classNames } from "../../../utils/classnames";
import { Link as AnchorLink } from "../../../utils/Link";

export default function NavigationHeader({
  baseUrl,
  educatorUrl,
  data,
  mobileData,
  Link,
  isUserRegistrationEnabled,
}) {
  const GamesClick = () => {
    window.location.href = "/company/games";
  };
  const loginThroughEducator = () => {
    window.location.href = educatorUrl;
  };

  const loginThroughUniverse = () => {
    window.location.href = "/login";
  };

  const registerClick = () => {
    window.location.href = "/registration";
  };

  return (
    <Disclosure
      as="nav"
      className="relative bg-black gn-nav"
      aria-label="Primary Navigation"
    >
      {({ open }) => (
        <>
          <div className="flex items-center justify-center h-navbar p-sm container">
            <div className="inset-y-0 flex items-center lg:hidden">
              {/* Mobile menu button */}
              <Disclosure.Button className="inline-flex items-center justify-center mr-sm p-xs rounded-md text-white hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-mint">
                <span className="sr-only">Open main menu</span>
                {open ? (
                  <XIcon className="block h-6 w-6" aria-hidden="true" />
                ) : (
                  <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                )}
              </Disclosure.Button>
            </div>
            <div className="w-full flex items-center justify-between">
              <Link
                href={`${baseUrl}/`}
                className="block flex-none"
                events={[
                  {
                    event: "Link Clicked",
                    properties: {
                      title: "GoNoodle Logo",
                      sourceElement: "nav",
                      sourceName: "nav",
                    },
                  },
                ]}
              >
                <span className="sr-only">GoNoodle</span>
                <img
                  style={{ width: "150px" }}
                  className="hidden lg:block lg:relative lg:transform lg:transition lg:hover:scale-110"
                  src="https://cdn.gonoodle.com/Universe-Component-Library/general/GoNoodleLogo_Registered_Reverse.svg"
                  alt="GoNoodle logo"
                />
                <svg
                  className="block transform transition hover:scale-110 lg:hidden lg:hover:scale-100"
                  width="51"
                  height="38"
                  viewBox="0 0 51 38"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M47.9584 28.6096L50.1257 32.3308C50.3206 32.6609 50.242 33.0837 49.9307 33.3172C46.0078 36.2594 41.0827 38.0061 35.7306 37.9999C31.5283 37.9954 27.5911 36.9129 24.1994 35.0192C23.8255 34.8101 23.7029 34.3443 23.9144 33.9803L26.0589 30.3031C26.2778 29.9272 26.7726 29.791 27.159 30.0075C29.682 31.4207 32.6114 32.233 35.7409 32.237C39.9215 32.2415 43.7516 30.8 46.7283 28.3993C47.1188 28.0844 47.7065 28.1834 47.9584 28.6096Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.309 0.70096C16.3055 0.298641 15.959 -0.0175083 15.5463 0.000753035C14.3766 0.0532543 13.1962 0.201627 12.0145 0.453291C7.65001 1.38291 3.90279 3.57826 1.07956 6.5674C0.709626 6.95888 0.730717 7.52898 1.12744 7.87138L3.92617 10.6808C4.34626 11.0437 5.02855 10.9981 5.43383 10.5929C7.50238 8.52764 10.1962 7.00739 13.3073 6.34484C14.0928 6.17764 14.8777 6.07093 15.6557 6.02128C16.0262 5.99788 16.3124 5.696 16.309 5.3342V0.70096Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.3991 11.09C19.241 11.09 24.7897 16.4641 24.7897 23.0911C24.7897 29.718 19.241 35.1001 12.3991 35.1001C5.54816 35.1001 0 29.718 0 23.0911C0 16.4641 5.54816 11.09 12.3991 11.09ZM13.3918 28.059C16.24 28.059 18.5482 25.8229 18.5482 23.0646C18.5482 20.3064 16.24 18.0702 13.3918 18.0702C10.5443 18.0702 8.23543 20.3064 8.23543 23.0646C8.23543 25.8229 10.5443 28.059 13.3918 28.059Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M35.5584 0.978394C43.3011 0.978394 49.5797 7.04857 49.5797 14.5348C49.5797 22.021 43.3011 28.1003 35.5584 28.1003C27.8064 28.1003 21.5279 22.021 21.5279 14.5348C21.5279 7.04857 27.8064 0.978394 35.5584 0.978394ZM34.6059 20.4398C37.7798 20.4398 40.3529 17.9518 40.3529 14.8831C40.3529 11.8145 37.7798 9.32646 34.6054 9.32646C31.4315 9.32646 28.8584 11.8145 28.8584 14.8831C28.8584 17.9518 31.4315 20.4398 34.6059 20.4398Z"
                    fill="white"
                  />
                </svg>
              </Link>

              <div className="hidden lg:flex mx-lg">
                <Popover.Group
                  role="navigation"
                  className="flex justify-between space-x-xs w-full"
                >
                  {data.map((item) => (
                    <Popover key={item.main_menu_item}>
                      {({ open: openMenu }) => (
                        <>
                          <Popover.Button
                            className={classNames(
                              openMenu
                                ? "text-white border-mint"
                                : "text-white",
                              "relative group rounded border-2 border-black inline-flex px-sm py-xs items-center focus:outline-none hover:border-mint",
                            )}
                          >
                            <span className="focus:outline-mint gn-text-sm font-bold group-hover:text-white">
                              {item.main_menu_item}
                            </span>
                          </Popover.Button>

                          <Transition
                            show={openMenu}
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="opacity-0 translate-y-md"
                            enterTo="opacity-100 translate-y-0"
                            leave="transition ease-in duration-150"
                            leaveFrom="opacity-100 translate-y-0"
                            leaveTo="opacity-0 translate-y-md"
                          >
                            <Popover.Panel
                              static
                              className="hidden md:block absolute z-10 top-xl transform -translate-x-sm"
                            >
                              {({ close }) => (
                                <div className="relative bg-white shadow-lg rounded">
                                  {/* 'Topics' and 'Channels' only have one item, so we check for the longer menus 'using item.nav_items.length'. */}
                                  <nav
                                    className={`grid space-x-md p-md ${
                                      item.nav_items.length < 2
                                        ? "grid-cols-1 w-screen-xs"
                                        : "grid-cols-3"
                                    } `}
                                  >
                                    {item.nav_items.map((navItem) => (
                                      <div
                                        key={navItem.heading}
                                        data-testid={navItem.testID}
                                      >
                                        {item.nav_items.length > 2 ? (
                                          <h3 className="gn-text-sm font-bold uppercase mb-sm">
                                            {navItem.heading}
                                          </h3>
                                        ) : null}

                                        <ul className="flex flex-col space-y-sm">
                                          {navItem.secondary_tags.map((tag) => (
                                            <li
                                              role="presentation"
                                              onClick={close}
                                              key={tag.name}
                                              className={`${
                                                item.nav_items.length < 2
                                                  ? "group bg-white hover:bg-gray-100 p-xs rounded py-sm"
                                                  : "py-xs"
                                              } `}
                                            >
                                              <Link
                                                href={`${baseUrl}${tag.slug}`}
                                                className={`block flex items-center space-x-md ${
                                                  item.nav_items.length < 2
                                                    ? "gn-text px-sm"
                                                    : "gn-text-sm hover:text-pink"
                                                } `}
                                                events={[
                                                  {
                                                    event: "Link Clicked",
                                                    properties: {
                                                      title: tag.name,
                                                      sourceElement: "nav",
                                                      sourceName: "nav",
                                                    },
                                                  },
                                                ]}
                                              >
                                                {navItem.heading ===
                                                "Channels" ? (
                                                  <img
                                                    className="block w-xl transform transition group-hover:scale-125 group-hover:-translate-y-xs"
                                                    src={tag.img}
                                                    alt={tag.name}
                                                  />
                                                ) : null}

                                                <div>
                                                  <span
                                                    className={` ${
                                                      item.nav_items.length < 2
                                                        ? "font-bold transform transition group-hover:text-pink group-hover:translate-x-1"
                                                        : null
                                                    } `}
                                                  >
                                                    {tag.name}
                                                  </span>
                                                  <p className="gn-text-xs">
                                                    {tag.description}
                                                  </p>
                                                </div>
                                              </Link>
                                            </li>
                                          ))}
                                          <li
                                            role="presentation"
                                            onClick={close}
                                          >
                                            <Link
                                              href={`${baseUrl}${navItem.slug}`}
                                              className={`block gn-text-sm font-bold mt-xs ${
                                                item.nav_items.length < 2
                                                  ? "text-center text-white bg-black p-sm rounded hover:bg-purple hover:text-white"
                                                  : "hover:text-purple"
                                              }`}
                                              events={[
                                                {
                                                  event: "Link Clicked",
                                                  properties: {
                                                    title: "Show All",
                                                    sourceElement: "nav",
                                                    sourceName: "nav",
                                                  },
                                                },
                                              ]}
                                            >
                                              <span>Show All</span>
                                            </Link>
                                          </li>
                                        </ul>
                                      </div>
                                    ))}
                                  </nav>
                                  {item.nav_items.length > 2 ? (
                                    <div className="flex px-md py-sm bg-gray-100 justify-between items-center">
                                      <Link
                                        href={`${baseUrl}/company/games`}
                                        className="hover:scale-150"
                                        events={[
                                          {
                                            event: "Link Clicked",
                                            properties: {
                                              title: "GoNoodle Games",
                                              sourceElement: "nav",
                                              sourceName: "nav",
                                            },
                                          },
                                        ]}
                                      >
                                        <span className="sr-only">
                                          GoNoodle Games!
                                        </span>
                                        <img
                                          className="inline-block mr-xs transform transition hover:scale-110 hover:-translate-y-xs"
                                          src="https://cdn.gonoodle.com/Universe-Component-Library/general/logo-gn-games.svg"
                                          alt="GoNoodle Games Logo"
                                        />{" "}
                                      </Link>
                                      <p className="gn-text-sm font-bold">
                                        Games that get kids moving!
                                      </p>
                                      <Button
                                        mode="light"
                                        size="sm"
                                        label="Learn More"
                                        onClick={GamesClick}
                                      />
                                    </div>
                                  ) : null}
                                </div>
                              )}
                            </Popover.Panel>
                          </Transition>
                        </>
                      )}
                    </Popover>
                  ))}
                </Popover.Group>
              </div>
              <div className="ml-md md:ml-lg flex flex-row">
                {isUserRegistrationEnabled ? (
                  <>
                    <Button
                      mode="light"
                      size="sm"
                      label="Create an Account"
                      onClick={registerClick}
                      className="mx-xs font-regular"
                    />
                    <Button
                      mode="light-outline"
                      size="sm"
                      label="Log In"
                      onClick={loginThroughUniverse}
                      className="mx-xs font-regular"
                    />
                  </>
                ) : (
                  <Button
                    mode="light"
                    size="sm"
                    label="Educator Log In"
                    onClick={loginThroughEducator}
                    className="mx-xs"
                  />
                )}
              </div>
            </div>

            <div className="hidden md:ml-4 md:flex-shrink-0 md:flex md:items-center">
              <Link href={`${baseUrl}/search`}>
                <button
                  type="button"
                  className="text-white hover:text-mint p-xs focus:outline-none"
                >
                  <span className="sr-only">Search</span>
                  <SearchIcon className="h-7 w-7" aria-hidden="true" />
                </button>
              </Link>

              {/* TODO: Profile dropdown */}
              {/* <Menu as="div" className="ml-3 relative">
                  {({ open: responsiveOpen }) => (
                    <>
                      <div>
                        <Menu.Button className="bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                          <span className="sr-only">Open user menu</span>
                          <img
                            className="h-8 w-8 rounded-full"
                            src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                            alt=""
                          />
                        </Menu.Button>
                      </div>
                      <Transition
                        show={responsiveOpen}
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items
                          static
                          className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                        >
                          <Menu.Item>
                            {({ active }) => (
                              <a
                                href="#"
                                className={classNames(
                                  active ? "bg-gray-100" : "",
                                  "block px-4 py-2 text-sm text-gray-700",
                                )}
                              >
                                Your Profile
                              </a>
                            )}
                          </Menu.Item>
                          <Menu.Item>
                            {({ active }) => (
                              <a
                                href="#"
                                className={classNames(
                                  active ? "bg-gray-100" : "",
                                  "block px-4 py-2 text-sm text-gray-700",
                                )}
                              >
                                Settings
                              </a>
                            )}
                          </Menu.Item>
                          <Menu.Item>
                            {({ active }) => (
                              <a
                                href="#"
                                className={classNames(
                                  active ? "bg-gray-100" : "",
                                  "block px-4 py-2 text-sm text-gray-700",
                                )}
                              >
                                Sign out
                              </a>
                            )}
                          </Menu.Item>
                        </Menu.Items>
                      </Transition>
                    </>
                  )}
                </Menu> */}
            </div>
          </div>

          {/* Mobile Nav Panel */}
          <Disclosure.Panel className="lg:hidden bg-gray-800">
            {({ close }) => (
              <div className="container px-lg pt-md pb-xl space-y-md">
                {mobileData.map((item) => (
                  <Link
                    key={item.name}
                    href={`${baseUrl}${item.slug}`}
                    className="flex items-center p-sm rounded focus:border-purple"
                    events={[
                      {
                        event: "Link Clicked",
                        properties: {
                          title: item.name,
                          sourceElement: "nav",
                          sourceName: "nav",
                        },
                      },
                    ]}
                  >
                    <div
                      role="presentation"
                      onClick={close}
                      className="gn-text-lg font-bold text-white"
                    >
                      {item.name}
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}

NavigationHeader.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      main_menu_item: PropTypes.string.isRequired,
      featured: PropTypes.shape({
        image: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        cta: PropTypes.string.isRequired,
        cta_link: PropTypes.string.isRequired,
      }),
      nav_items: PropTypes.arrayOf(
        PropTypes.shape({
          heading: PropTypes.string.isRequired,
          slug: PropTypes.string.isRequired,
          secondary_tags: PropTypes.arrayOf(
            PropTypes.shape({
              name: PropTypes.string.isRequired,
              description: PropTypes.string.isRequired,
              slug: PropTypes.string.isRequired,
            }),
          ),
        }),
      ),
    }),
  ),
  baseUrl: PropTypes.string,
  educatorUrl: PropTypes.string,
  mobileData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
    }),
  ),
  Link: PropTypes.func,
  isUserRegistrationEnabled: PropTypes.bool,
};

NavigationHeader.defaultProps = {
  data: sampleData,
  mobileData: mobileNav,
  baseUrl: "",
  educatorUrl: "",
  Link: AnchorLink,
  isUserRegistrationEnabled: false,
};
